import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import useResizeObserver from 'use-resize-observer'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import Hero from '@/components/Feature/Hero'
import ArticleCard from '@/components/Articles/Card'
import { useResizer } from '../contexts/Resizer'

import { useStaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'

let animations = {
  enter: {
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
}

const VideoWrap = styled.div`
  background-color: black;
  position: relative;
  z-index: 2;
  > div {
    position: relative;
    padding-top: 42.25%;
    height: 0;
    overflow: hidden;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    @media (max-width: 1200px) {
      padding-top: 124.25%;
    }
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`

const IndexPage = () => {
  const { ref, width, height } = useResizeObserver()
  const setArea = useResizer()

  const data = useStaticQuery(graphql`
    query mgposts($fields: [WpPostFieldsEnum] = date) {
      allWpPost(
        filter: {
          categories: {
            nodes: { elemMatch: { name: { eq: "Novo Insulina" } } }
          }
        }
        sort: { fields: $fields, order: DESC }
      ) {
        edges {
          node {
            slug
            title
            excerpt
            featuredImage {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: CONSTRAINED, quality: 90)
                  }
                }
              }
            }
            postFormats {
              nodes {
                name
              }
            }
            date
          }
        }
      }
    }
  `)

  // console.log(typeof setArea, setArea)

  useEffect(() => {
    console.log(setArea, width, height)
    if (setArea) {
      console.log('setArea is finally setted!')
      let timeout = setTimeout(() => {
        setArea(area => {
          if (area.width !== width || area.height !== height) {
            return { width, height }
          } else {
            return area
          }
        })
      }, 150)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [width, height, setArea])

  return (
    <motion.div
      ref={ref}
      initial="exit"
      animate="enter"
      exit="exit"
      variants={animations}>
      <Layout>
        <SEO title="100 años de la Insulina" />
        <Hero
          titleLine1="100 años de la"
          titleLine2="Insulina"
          subtitle="Hoy en día gran parte de la población está familiarizada con las propiedades de la insulina, y la importancia que tiene esta hormona en nuestro organismo. Pero es más conocida por ser el principal tratamiento para el control de la diabetes I y II, enfermedad que afecta a 537 millones de personas en el mundo y que cumple 100 años desde su descubrimiento."></Hero>

        <VideoWrap>
          <div>
            <iframe
              id="vrudo"
              class="vrudo"
              src="https://rudo.video/vod/bNhIJR?stv=1&autoplay=0&volume=0"
              width="560"
              height="315"
              allowscriptaccess="always"
              allowfullscreen="true"
              webkitallowfullscreen="true"
              frameborder="0"
              scrolling="no"
              allow="autoplay; fullscreen"></iframe>
          </div>
        </VideoWrap>
        {data.allWpPost.edges.map((edge, index) => (
          <ArticleCard
            key={edge.node.slug}
            odd={index % 2 === 0}
            title={edge.node.title}
            excerpt={edge.node.excerpt}
            slug={edge.node.slug}
            featuredImage={edge.node.featuredImage}
            index={index}
            type={
              edge.node.postFormats?.nodes[0]?.name === 'Video'
                ? 'video'
                : 'article'
            }
          />
        ))}
      </Layout>
    </motion.div>
  )
}

export default IndexPage
